import { render, staticRenderFns } from "./LoadingCards.vue?vue&type=template&id=163cb17c&scoped=true"
import script from "./LoadingCards.vue?vue&type=script&lang=js"
export * from "./LoadingCards.vue?vue&type=script&lang=js"
import style0 from "./LoadingCards.vue?vue&type=style&index=0&id=163cb17c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163cb17c",
  null
  
)

export default component.exports